import { useMemo } from "react";
import { FilterInput } from "../types";
import { filters } from "../filters";
import { useFilterFieldOptions } from "@/components/FilterSidebar/hooks/useFilterFieldsOptions";

export type FilterProps = Record<string, FilterInput>;

export const useFilters = () => {
  const { options, loading } = useFilterFieldOptions();

  const filtersWithOptions: FilterProps | null = useMemo(() => {
    if (loading) return null;

    if (options) {
      return Object.fromEntries(
        filters.map((filter) => [
          filter.name,
          filter.name in options
            ? {
                ...filter,
                options: options[filter.name as keyof typeof options],
              }
            : filter,
        ]),
      );
    }
    return Object.fromEntries(filters.map((filter) => [filter.name, filter]));
  }, [options, loading]);

  return { filters: filtersWithOptions, loading };
};
